import {
  SET_BOARDID,
  GET_BOARDDATA_SUCCESS,
  SET_IMAGE,
  CLEAR_BOARD,
  CLEAR_IMAGE,
  GET_COMMENT,
} from './actions';

const initState = {};

const board = (state = initState, action) => {
  switch (action.type) {
  case SET_BOARDID:
    return {
      ...state,
      ...action.id,
    };
  case SET_IMAGE:
    return{
      ...state,
      ...action.image,
    };
  case CLEAR_BOARD:
    return{};
  case CLEAR_IMAGE:
    return{
      ...state,
      img: null
    };
  case GET_BOARDDATA_SUCCESS:
    return {
      ...state,
      data: action.data,
    };
  case GET_COMMENT:
    return {
      ...state,
      comment: action.data,
    };
  default:
    return state;
  }
};

export default board;



// WEBPACK FOOTER //
// ./src/redux/board/reducer.js